import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import TabelsPages from "@/components/modules/Assets/TabelsPages/TabelsPages";
import { Categories } from "../../../../components/modules/Assets/Categories";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import Cards from "components/modules/Assets/cards/index";

type Res = {
  subData?: any;
  label?: string;
  path?: string;
  icon?: any;
};
export default function InnerAssets() {
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const SubCategorie = router.query;
  const [getSubCategories, setGetSubCategories] = useState([]);

  useEffect(() => {
    const FilterData = Categories(t).find(
      (word) => word.path.replace("assets/", "") === SubCategorie.pages
    );
    const Result = FilterData?.subData;
    const DataRes: Res = Result?.find(
      (word) =>
        word.path.replace("irrigation-network/", "") === SubCategorie.innerPage
    );
    const ResSubCategories = DataRes?.subData;
    setGetSubCategories(ResSubCategories);
  }, [SubCategorie]);
  return (
    <div className="w-full min-h-full bg-[#F5F5F5] py-3 px-5">
      {getSubCategories?.length > 0 && (
        <div className="flex items-center">
          <div
            onClick={() => router.push("/assets")}
            className="xl:text-[36px] text-[30px]  capitalize cursor-pointer"
          >
            {t("Assets")}
          </div>
          <p className="text-black ">
            {i18n.language === "ar" ? (
              <MdKeyboardArrowLeft size="2rem" />
            ) : (
              <MdKeyboardArrowRight size="2rem" />
            )}
          </p>
          <div
            onClick={() => router.push(`/assets/${SubCategorie.pages}`)}
            className="xl:text-[36px] text-[30px]  capitalize cursor-pointer"
          >
            {t(`${SubCategorie.pages}`)?.replaceAll("-", " ")}
          </div>

          <p className="text-black ">
            {i18n.language === "ar" ? (
              <MdKeyboardArrowLeft size="2rem" />
            ) : (
              <MdKeyboardArrowRight size="2rem" />
            )}
          </p>
          <div className="text-[36px]  capitalize ">
            {t(`${SubCategorie.innerPage}`)?.replaceAll("-", " ")}
          </div>
        </div>
      )}
      <TabelsPages />
      <div className="grid h-full gap-2 mt-2 md:grid-cols-3 sm:grid-cols-2 lg:gap-4 2xl:grid-cols-5">
        {getSubCategories?.map((item, index) => (
          <Cards
            image={item.icon}
            color={item.color}
            path={item.path}
            title={item.label}
            p={item.p}
          />
        ))}
      </div>
    </div>
  );
}
